import { OktaAuth } from '@okta/okta-auth-js'

const issuer = import.meta.env.VITE_OKTA_ISSUER ?? ''
const clientId = import.meta.env.VITE_OKTA_CLIENT_ID ?? ''
const redirectUri =
  import.meta.env.VITE_OKTA_REDIRECT_URI ??
  (typeof window !== 'undefined' ? `${window.location.origin}/login/callback` : '')

export function isOktaConfigured(): boolean {
  return Boolean(issuer?.trim() && clientId?.trim())
}

export function getOktaRedirectUri(): string {
  return redirectUri || (typeof window !== 'undefined' ? `${window.location.origin}/login/callback` : '')
}

let oktaAuthInstance: OktaAuth | null = null

/**
 * Returns an OktaAuth instance when VITE_OKTA_ISSUER and VITE_OKTA_CLIENT_ID are set.
 * Otherwise returns null (app runs in legacy email/password mode).
 */
export function getOktaAuth(): OktaAuth | null {
  if (!isOktaConfigured()) {
    return null
  }
  if (!oktaAuthInstance) {
    oktaAuthInstance = new OktaAuth({
      issuer: issuer.trim(),
      clientId: clientId.trim(),
      redirectUri: getOktaRedirectUri(),
      scopes: ['openid', 'profile', 'email', 'groups'],
      pkce: true,
    })
  }
  return oktaAuthInstance
}
